// extracted by mini-css-extract-plugin
export default {"imageContainer":"styles__imageContainer___kM498","personData":"styles__personData___CYVeu","title":"styles__title___wgftZ","bodyCard":"styles__bodyCard___FbhE_"};